import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { Container, Divider, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import TwoFacIcon from "../../../assets/Vector (5).png";
import TradeIcon from "../../../assets/Vector (2).png";
import VarizBardashIcon from "../../../assets/Vector (4).png";
import BuySellIcon from "../../../assets/Vector (3).png";
import UserRegisterIcon from "../../../assets/Vector (6).png";
import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import EtcIcon from "../../../assets/etcpng.png";
import { Link } from "react-router-dom";
import "./AccardionGuid.css";
import FaqIcon from "../../../assets/faq-icon.png";
import MinimizeIcon from "@mui/icons-material/Minimize";
import AddIcon from "@mui/icons-material/Add";

const Tab = styled(TabUnstyled)`
  background-color: #1b1c31;
  padding: 10px 0;
  border: 1px solid #3f4051;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  width: 100%;
  height: 10rem;
  align-items: center;
  justify-content: center;

  &:hover {
  }

  &:focus {
    color: #fff;
  }

  &.${tabUnstyledClasses.selected} {
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
    border: none;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)(
  ({ theme }) => `
    width: 100%;
    margin-top:2rem;
    background-color: background.darkBlue;
    border-radius: 10px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;  

    `
);

export function ControlledAccordions() {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Grid container sx={{ justifyContent: "center", mt: 15, mb: 4 }}>
      <Grid item xs={12} md={12}>
        <Accordion
          disableGutters
          sx={{
            borderRadius: "10px !important",
            p: 1,
            my: 2,
            bgcolor: "background.darkBlack",
          }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel1" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            sx={{ borderRadius: "10px" }}
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel2" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}

export default function AccardionGuid() {
  const { t } = useTranslation();

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ mx: 0, px: 0, bgcolor: "inherit" }}>
      <Container maxWidth="xl" sx={{ px: { xs: 0 } }}>
        <Box sx={{ pb: 3, pt: 0 }}>
          <TabsUnstyled defaultValue={0}>
            <TabsList>
              <Grid container spacing={3} columns={{ xs: 5, sm: 10, md: 15 }}>
                <Grid item xs={12} sm={5} md={3}>
                  <Link
                    to="https://panel.parsianbit.com/signup"
                    className="link_box_parent"
                  >
                    <Tab value={0}>
                      <Box sx={{ mt: 2 }}>
                        <img
                          src={UserRegisterIcon}
                          alt="icon image"
                          width="100%"
                        />
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{ mt: 2 }}
                        component="span"
                        color="text.title"
                        className="link_box"
                      >
                        {t("register_and_auth")}
                      </Typography>
                    </Tab>
                  </Link>
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <Link
                    to="https://panel.parsianbit.com/verification"
                    className="link_box_parent"
                  >
                    <Tab value={1}>
                      <Box sx={{ mt: 2 }}>
                        <img src={TwoFacIcon} alt="icon image" width="100%" />
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{ mt: 2 }}
                        component="span"
                        color="text.title"
                        className="link_box"
                      >
                        {t("two_fac_auth")}
                      </Typography>
                    </Tab>
                  </Link>
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <Link
                    to="https://panel.parsianbit.com/wallet"
                    className="link_box_parent"
                  >
                    <Tab value={2}>
                      <Box sx={{ mt: 2 }}>
                        <img
                          src={VarizBardashIcon}
                          alt="icon image"
                          width="100%"
                        />
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{ mt: 2 }}
                        component="span"
                        color="text.title"
                        className="link_box"
                      >
                        {t("harvest_deposit")}
                      </Typography>
                    </Tab>
                  </Link>
                </Grid>

                <Grid item xs={12} sm={5} md={3}>
                  <Link
                    to="https://panel.parsianbit.com/trade"
                    className="link_box_parent"
                  >
                    <Tab value={3}>
                      <Box sx={{ mt: 2 }}>
                        <img src={BuySellIcon} alt="icon image" width="100%" />
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{ mt: 2 }}
                        component="span"
                        color="text.title"
                        className="link_box"
                      >
                        {t("buy_sell")}
                      </Typography>
                    </Tab>
                  </Link>
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <Link
                    to="https://panel.parsianbit.com/faq"
                    className="link_box_parent"
                  >
                    <Tab value={4}>
                      <Box sx={{ mt: 1 }}>
                        <img src={TradeIcon} alt="icon image" width="100%" />
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{ mt: 2 }}
                        component="span"
                        color="text.title"
                        className="link_box"
                      >
                        {t("film")}
                      </Typography>
                    </Tab>
                  </Link>
                </Grid>
              </Grid>
            </TabsList>
            <Box sx={{ mt: 6.5, mb: 4 }}></Box>
            <TabPanel value={0}>
              <ControlledAccordions />
            </TabPanel>
            <TabPanel value={1}>
              <ControlledAccordions />
            </TabPanel>
            <TabPanel value={2}>
              <ControlledAccordions />
            </TabPanel>
            <TabPanel value={3}>
              <ControlledAccordions />
            </TabPanel>
            <TabPanel value={4}>
              <ControlledAccordions />
            </TabPanel>
            <TabPanel value={5}>
              <ControlledAccordions />
            </TabPanel>
          </TabsUnstyled>
        </Box>
      </Container>
    </Box>
  );
}
